<input [ngClass]="{'input-default': inputStyle === 'default', 'input-rounded': inputStyle === 'rounded'}"
       [ngStyle]="{'font-size': inputSize}"
       [type]="inputType" class="form-control"
       [min]="minDate"
       [max]="maxDate">
